import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import FormButtons from '../../../core/form/FormButtons';
import Switch from '../../../core/form/Switch';

const WhitelabelConfigCustomOptionsForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={2}>
        <TextInput
          type="number"
          required
          disabled={props.submitting}
          label="Time to allow to continue unit"
          value={get(props.values, 'timeToAllowContinueUnit', '')}
          onChange={(value) => props.onChange('timeToAllowContinueUnit', value)}
          errorText={get(props.errors, 'timeToAllowContinueUnit', null)}
        />
      </Column>
      <Column size={2}>
        <Switch
          required
          disabled={props.submitting}
          label="Use simple Speech Recognition"
          value={get(props.values, 'simpleSpeechRecognition', '')}
          onChange={(value) => props.onChange('simpleSpeechRecognition', value)}
          errorText={get(props.errors, 'simpleSpeechRecognition', null)}
          titleOn="Yes"
          titleOff="No"
        />
      </Column>
      <Column size={2}>
        <Switch
          required
          disabled={props.submitting}
          label="Disable email sending"
          value={get(props.values, 'disableEmailSending', '')}
          onChange={(value) => props.onChange('disableEmailSending', value)}
          errorText={get(props.errors, 'disableEmailSending', null)}
          titleOn="Yes"
          titleOff="No"
        />
      </Column>
      <Column size={2}>
        <Switch
          required
          disabled={props.submitting}
          label="Disable student support"
          value={get(props.values, 'disableStudentSupport', '')}
          onChange={(value) => props.onChange('disableStudentSupport', value)}
          errorText={get(props.errors, 'disableStudentSupport', null)}
          titleOn="Yes"
          titleOff="No"
        />
      </Column>
    </Row>
    <Row>
      <Column size={2}>
        <Switch
          required
          disabled={props.submitting}
          label="Disable study quality"
          value={get(props.values, 'disableStudyQuality', '')}
          onChange={(value) => props.onChange('disableStudyQuality', value)}
          errorText={get(props.errors, 'disableStudyQuality', null)}
          titleOn="Yes"
          titleOff="No"
        />
      </Column>
      <Column size={2}>
        <Switch
          required
          disabled={props.submitting}
          label="Enable all course content"
          value={get(props.values, 'enableAllCourseContent', '')}
          onChange={(value) => props.onChange('enableAllCourseContent', value)}
          errorText={get(props.errors, 'enableAllCourseContent', null)}
          titleOn="Yes"
          titleOff="No"
        />
      </Column>
      <Column size={2}>
        <Switch
          required
          disabled={props.submitting}
          label="Disable Flexge courses and Placement"
          value={get(props.values, 'disableFlexgeCourse', '')}
          onChange={(value) => props.onChange('disableFlexgeCourse', value)}
          errorText={get(props.errors, 'disableFlexgeCourse', null)}
          titleOn="Yes"
          titleOff="No"
        />
      </Column>
    </Row>
    <FormButtons
      confirmLabel="Update custom options"
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

WhitelabelConfigCustomOptionsForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

WhitelabelConfigCustomOptionsForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onReset: () => false,
};

export default WhitelabelConfigCustomOptionsForm;
